import { Redirect } from "react-router-dom";
import type { Location } from "history";

import routesObject from "../../routesObject";

interface PrivacyPolicyRedirectProps {
  location: Location;
}

export default function PrivacyPolicyRedirect({ location }: PrivacyPolicyRedirectProps) {
  // Type assertion to work around React Router v5 + React 17 type conflicts
  const RedirectComponent = Redirect as any;
  return (
    <RedirectComponent to={`${routesObject.privacyPolicy.url}${location.search}`} />
  );
}
